import { useMemo } from 'react';
// @ts-ignore
import { isNullOrUndefined } from '@gp/utils/utils';

export default function useMilestones(milestoneData: any) {
  const isMilestoneValid = (milestone: any) => {
    if (!milestone) return false;
    return !isNullOrUndefined(milestone.milestone);
  };

  const getMilestonesOptions = (sources: any[]) => {
    if (!Array.isArray(sources)) return [];
    return sources.filter(isMilestoneValid).map((item, index) => {
      const nextMilestone = sources[index + 1];
      const text = nextMilestone ? `${item?.milestone} to ${nextMilestone.milestone}` : item?.milestone;
      return {
        ...item,
        text,
        value: item?.milestone,
      };
    });
  };

  const milestones = useMemo(() => {
    return getMilestonesOptions(milestoneData?.list);
  }, [milestoneData]);

  return {
    milestones,
  };
}
